(function () {
  'use strict';

  var state = {
    observer: null,
    loading: false,
    controller: null
  };

  function cleanup() {
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }
    if (state.controller) {
      state.controller.abort();
      state.controller = null;
    }
    state.loading = false;
  }

  function refreshProductFeatures() {
    if (!window.theme) return;

    ['wishlist', 'compare', 'countdown', 'swatchCard2', 'tooltip'].forEach(function (key) {
      try {
        if (window.theme[key] && typeof window.theme[key].load === 'function') {
          window.theme[key].load();
        }
      } catch (error) {
        console.warn('[Collection infinite scroll] Could not refresh ' + key, error);
      }
    });

    try {
      if (window.SPR && window.theme.review) {
        window.SPR.registerCallbacks();
        window.SPR.initRatingHandler();
        window.SPR.initDomEls();
        window.SPR.loadProducts();
        window.SPR.loadBadges();
      }
    } catch (error) {
      console.warn('[Collection infinite scroll] Could not refresh reviews', error);
    }
  }

  function setLoading(pagination, loading) {
    var link = pagination ? pagination.querySelector('a') : null;
    if (!link) return;

    if (loading) {
      if (!link.dataset.originalHtml) link.dataset.originalHtml = link.innerHTML;
      link.setAttribute('aria-busy', 'true');
      link.innerHTML = '<span class="loader-line"></span>';
    } else {
      link.removeAttribute('aria-busy');
      if (link.dataset.originalHtml) link.innerHTML = link.dataset.originalHtml;
    }
  }

  async function loadNextPage(grid, pagination) {
    if (state.loading) return;

    var nextLink = pagination.querySelector('a[href]');
    if (!nextLink) {
      cleanup();
      pagination.style.display = 'none';
      return;
    }

    state.loading = true;
    setLoading(pagination, true);
    state.controller = new AbortController();

    try {
      var response = await fetch(nextLink.href, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: state.controller.signal
      });

      if (!response.ok) throw new Error('HTTP ' + response.status);

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('#ProductGridContainer .AjaxinateLoop');
      var newPagination = doc.querySelector('#ProductGridContainer .AjaxinatePagination');

      if (!newGrid) throw new Error('Next page product grid was not found');

      var fragment = document.createDocumentFragment();
      Array.prototype.slice.call(newGrid.children).forEach(function (item) {
        fragment.appendChild(item.cloneNode(true));
      });
      grid.appendChild(fragment);

      if (newPagination) {
        pagination.innerHTML = newPagination.innerHTML;
        pagination.style.display = '';
      } else {
        pagination.innerHTML = '';
        pagination.style.display = 'none';
      }

      refreshProductFeatures();
      document.dispatchEvent(new CustomEvent('coral:infinite-scroll-loaded', {
        detail: { url: nextLink.href }
      }));
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('[Collection infinite scroll] Failed to load next page:', error);
        setLoading(pagination, false);
      }
    } finally {
      state.loading = false;
      state.controller = null;
    }
  }

  function init() {
    cleanup();

    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    var grid = container.querySelector('.AjaxinateLoop');
    var pagination = container.querySelector('.AjaxinatePagination[data-pagination="scroll"]');
    if (!grid || !pagination) return;

    var nextLink = pagination.querySelector('a[href]');
    if (!nextLink) {
      pagination.style.display = 'none';
      return;
    }

    // Keep the link as a functional fallback if IntersectionObserver is unavailable.
    nextLink.addEventListener('click', function (event) {
      event.preventDefault();
      loadNextPage(grid, pagination);
    }, { once: true });

    if (!('IntersectionObserver' in window)) return;

    state.observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        loadNextPage(grid, pagination);
      }
    }, {
      root: null,
      rootMargin: '600px 0px',
      threshold: 0
    });

    state.observer.observe(pagination);
  }

  window.initCollectionInfiniteScroll = init;
  // Compatibility for the facets file that previously called this name.
  window.initCollectionAjaxinate = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('coral:facets-complete', function () {
    requestAnimationFrame(init);
  });

  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(init);
  });
})();
